module.exports = __webpack_public_path__ + "images/meater-report-mockup@2x_6922480.png";